// extracted by mini-css-extract-plugin
export var noSpinners = "_nh-6";
export var percentageInput = "_nh-7";
export var variantColor1 = "_nh-0";
export var variantColor2 = "_nh-1";
export var variantColor3 = "_nh-2";
export var variantColor4 = "_nh-3";
export var variantColor5 = "_nh-4";
export var variantColor6 = "_nh-5";